<script>
  export let busqueda = "";
</script>

<input type="search" id="Buscador" bind:value={busqueda} />
